var map = {
	"./b.png": 128,
	"./buld.jpg": 129,
	"./cwoc.png": 130,
	"./efi.png": 131,
	"./femaledev.png": 132,
	"./flutter.png": 133,
	"./gdg.png": 134,
	"./github.png": 135,
	"./googleAssistant.jpg": 136,
	"./google_logo.png": 137,
	"./gtu.png": 138,
	"./hackathon1.svg": 139,
	"./harikrushn.jpg": 140,
	"./home-female.svg": 141,
	"./iit.png": 142,
	"./ino.png": 143,
	"./localguide.gif": 144,
	"./localguide.png": 145,
	"./mlh-logo.png": 146,
	"./mlh-logo.svg": 147,
	"./mlh.png": 148,
	"./mongo.png": 149,
	"./nightowls.jpeg": 150,
	"./nightowls.jpg": 151,
	"./postman.jpg": 152,
	"./postman.png": 153,
	"./skillenza.png": 154,
	"./ssec.png": 155,
	"./ssec1.png": 156,
	"./ssgandhy.png": 157,
	"./valora.jpeg": 158,
	"./valora.jpg": 159,
	"./wrighter.jpg": 160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;